import React from 'react'
import ErrorIcon from '@material-ui/icons/Error'
import CheckIcon from '@material-ui/icons/Check'
import { StepTitleProps } from '..'

export const DesktopStepTitle = (props: StepTitleProps) => {
  const indexContainerClasses =
    'w-8 h-8 flex items-center justify-center rounded-full border border-2 truncate'

  const getTextStyles = (type: StepTitleProps['type']) => {
    if (type === 'current') return 'text-mm-primary-600'
    if (type === 'complete') return 'text-mm-neutral-1-900 lg:block'
    if (type === 'error') return 'text-mm-warning-600'
    if (type === 'upcoming') return 'text-mm-neutral-1-500 group-hover:text-mm-neutral-1-600'
    return ''
  }

  return (
    <>
      <li
        key={props.stepNumber}
        className={`flex transition-all justify-between duration-300 h-16 truncate group ${
          props.type === 'current' ? '' : '' // I'm undecided on whether to add grow/shrink
        }`}
      >
        <button
          onClick={props.onClick}
          // `focus:outline-none` with nothing in its place left keyboard users with
          // no way to see which step they were on, so the ring is the replacement.
          className={
            'flex items-center justify-center truncate w-full space-x-2 rounded outline-none focus-visible:ring-2 focus-visible:ring-mm-primary-500'
          }
        >
          {props.type === 'current' && (
            <span className={`${indexContainerClasses} text-mm-primary-600 border-mm-primary-600`}>
              <span className="h-6 w-6">{props.stepNumber}</span>
            </span>
          )}

          {props.type === 'complete' && (
            <span
              className={`${indexContainerClasses} border-none bg-mm-primary-600 group-hover:bg-mm-primary-700`}
            >
              <CheckIcon className="w-6 h-6 text-white" />
            </span>
          )}

          {props.type === 'error' && (
            <span
              data-testid="error-icon"
              className={`${indexContainerClasses} border-2 border-mm-warning-500`}
            >
              <ErrorIcon className="w-5 h-5 text-mm-warning-500" />
            </span>
          )}

          {props.type === 'upcoming' && (
            <span
              className={`${indexContainerClasses} border-2 border-mm-neutral-1-300 group-hover:border-mm-neutral-1-400`}
            >
              <span className="text-mm-neutral-1-500 group-hover:text-mm-neutral-1-900">
                {props.stepNumber}
              </span>
            </span>
          )}

          <span className={`text-sm font-medium truncate ${getTextStyles(props.type)}`}>
            {props.title}
          </span>
        </button>
      </li>
      {!props.isLast && (
        <svg
          className={'h-full w-5 text-mm-neutral-1-200'}
          viewBox="0 0 22 80"
          fill="none"
          preserveAspectRatio="none"
        >
          <path
            d="M0 -2L20 40L0 82"
            vectorEffect="non-scaling-stroke"
            stroke="currentcolor"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </>
  )
}
